import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";
import Training from "./tabs/Training";

const qualificationTabs = [
  {
    title: "Повышение квалификации (НМО)",
    component: <Training />,
  },
];

const Qualification: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {qualificationTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {qualificationTabs[tab].component}
    </Wrapper>
  );
};

export default Qualification;
